<template>
  <div class="widget" ref="widgetRef">
    <div class="widget__hdr">
      <span class="widget__ttl">
        <ArrowBack @click="close()" class="widget__arrow" v-if="isLessThanSM"/> Уведомления
      </span>
      <button class="widget__btn-mark-all" @click="markAllNotifications">Прочитать все</button>
    </div>
    <div class="widget__ldr" v-if="!isListReady">
      <LoaderCircleWrapper :color="'var(--circle-loader)'"/>
    </div>
    <div 
      class="widget__scroll-box" 
      :class="{ 'widget__scroll-box--top': !isAtTop, 'widget__scroll-box--bottom': !isAtBottom }" 
      v-else-if="notificationsList.length > 0 || !isTelegram"
    >
      <NotificationsList class="widget__list" @scroll="handleScroll" ref="scrollContainer"/>
    </div>
    <NoNotifications class="widget__zero-block" v-else-if="notificationsList.length === 0"/>
  </div>
</template>

<script setup>
import {useStore} from 'vuex';
import {ref, onMounted, onUnmounted, nextTick} from 'vue'
import { useUserAuth } from '@/Groups/Notifications/private/imports/userStoreData';
import {useNotificationsState} from '@/Groups/Notifications/private/composables/computedValues';
import {useNotificationsDropdown} from '@/Groups/Notifications/private/imports/toggleDropdown';
//-----------------------------
import NotificationsList from '@/Groups/Notifications/private/core/NotificationsList/NotificationsList.vue';
import {LoaderCircleWrapper} from '@/Groups/Notifications/private/imports/externalTemplates';
import NoNotifications from '@/Groups/Notifications/private/ui/NoNotifications/NoNotifications.vue';
import ArrowBack from "@/Groups/Notifications/private/svg/ArrowBack.vue";
import {useScreenSize} from "@shared/composables/screenWidth/useScreenSize";
//-----------------------------
const store = useStore();
//-----------------------------
const {notificationsList, isListReady} = useNotificationsState();
//-----------------------------
const { isTelegram } = useUserAuth();
//-----------------------------
const { close } = useNotificationsDropdown();
//---------------------------------
const {isLessThanSM} = useScreenSize();
//-----------------------------
const scrollContainer = ref(null);
const isAtTop = ref(true);
const isAtBottom = ref(false);
const widgetRef = ref(null);
//-----------------------------
onMounted(async () => {
  await store.dispatch('Notifications/fetchNotifications', {reset: true});
  await nextTick();
  if (scrollContainer.value) {
    const el = scrollContainer.value.$el;
    handleScroll({target: el});
  }
  document.addEventListener('click', handleClickOutside);
})
onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside);
  close();
})
//-----------------------------
//Клик вне области
const handleClickOutside = (event) => {
  if (widgetRef.value && !widgetRef.value.contains(event.target)) {
    close();
  }
};
//Обработчик скролла
const handleScroll = (e) => {
  const {scrollTop, scrollHeight, clientHeight} = e.target;
  const tolerance = 1;
  isAtTop.value = scrollTop <= tolerance;
  isAtBottom.value = scrollHeight - (scrollTop + clientHeight) <= tolerance;
  if (isAtBottom.value) {
    store.dispatch('Notifications/loadNextPage');
  }
}
//Отметить все нотификации, как прочитанные
const markAllNotifications = () => {
  store.dispatch('Notifications/markAllAsRead');
};
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>

